import { Grid, Theme } from '@mui/material';
import GVIconButton from 'components/lib/GVIconButton/GVIconButton';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { makeStyles } from 'tss-react/mui';
import { CustomStatus } from 'store/queries/organizations/useCustomStatuses';
import F1Icon from 'components/icons/HotkeyIcons/F1';
import F2Icon from 'components/icons/HotkeyIcons/F2';
import F3Icon from 'components/icons/HotkeyIcons/F3';
import GVChip from 'components/GVChip/GVChip';

interface CustomStatusButtonProps {
  status?: CustomStatus;
  key?: any;
  handleSelectStatus: (e: React.SyntheticEvent) => void;
  className?: string;
  selected?: boolean;
}

const useStyles = makeStyles()((theme: Theme) => {
  return {
    hotkeyBox: {
      fontSize: '15px',
      marginLeft: '3px',
    },
    customBadge: {
      backgroundColor: 'transparent !important',
      overflow: 'hidden',
      '& .MuiChip-label': {
        paddingTop: theme.spacing(0.2),
        height: '100%',
        paddingLeft: theme.spacing(1),
      },
    },
    icons: {
      maxWidth: theme.spacing(2),
      maxHeight: theme.spacing(2),
      margin: theme.spacing(0.5),
      cursor: 'pointer',
    },
  };
});

const CustomStatusButton = ({ status, handleSelectStatus, className, selected }: CustomStatusButtonProps) => {
  const { classes } = useStyles();
  const maxTitleLength = 18;

  const getIcon = () => {
    const color = selected ? getColor() : undefined;
    switch (status?.icon) {
      case 'Thumbup':
        return (
          <ThumbUpAltIcon
            className={classes.icons}
            style={{
              fontSize: 14,
              color: color || undefined,
            }}
          />
        );
      case 'Thumbdown':
        return (
          <ThumbDownOffAltIcon
            className={classes.icons}
            style={{
              fontSize: 14,
              color: color || undefined,
            }}
          />
        );
      case 'Hidden':
        return (
          <VisibilityOffOutlinedIcon
            className={classes.icons}
            style={{
              fontSize: 14,
              color: color || undefined,
            }}
          />
        );
    }
  };

  const getColor = () => {
    switch (status?.color) {
      case 'Green':
        return '#19CAD7';
      case 'Red':
        return '#EA3632';
      case 'Blue':
        return '#5586F1';
      default:
        return '';
    }
  };

  const getIconTooltip = () => {
    if (status?.statusType === 'First') {
      return <F1Icon className={classes.hotkeyBox} />;
    } else if (status?.statusType === 'Second') {
      return <F2Icon className={classes.hotkeyBox} />;
    } else {
      return <F3Icon className={classes.hotkeyBox} />;
    }
  };
  return (
    <>
      {selected ? (
        <GVTooltip title="Remove status" side="bottom" arrow>
          <span>
            <GVChip
              className={classes.customBadge}
              sx={{
                '& .MuiChip-label': {
                  backgroundColor:
                    status?.color === 'Green' ? '#2E5C5F' : status?.color === 'Red' ? '#6B3433' : '#2B68ED40',
                },
              }}
              data-testid="custom_status_chip"
              label={
                <Grid container item wrap={'nowrap'} alignItems={'center'} width={'100%'}>
                  {getIcon()} {status?.title}
                </Grid>
              }
              onClick={(e) => {
                e.stopPropagation();
                handleSelectStatus(e);
              }}
            />
          </span>
        </GVTooltip>
      ) : (
        <GVTooltip
          title={
            <Grid container>
              {status?.title} {getIconTooltip()}
            </Grid>
          }
          side="bottom"
          arrow
        >
          <GVIconButton
            color="primary"
            size="small"
            sx={{
              transition: 'color 0.2s ease',
              '&:hover': {
                color: getColor(),
              },
            }}
            icon={getIcon()!}
            className={className}
            onClick={(e) => {
              e.stopPropagation();
              handleSelectStatus(e);
            }}
          />
        </GVTooltip>
      )}
    </>
  );
};

export default CustomStatusButton;
